import styled from "styled-components";
import { BackOutlined } from "@assets";
import { IMG_TOP_BG } from "@assets";

const boxShadowStyle =
  "rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px";
export const barColor = "linear-gradient(0deg, #6D1D7A, #94378C)";

export const Bar = styled.div`
  min-height: 70px;
  padding-inline: 15px 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: ${(props) =>
    props.bg === "transparent" ? "transparent" : barColor};
  box-shadow: ${(props) =>
    props.bg === "transparent" ? "none" : boxShadowStyle};
  z-index: 1000;
`;

export const Title = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;

  @media screen and (max-width: 325px) {
    font-size: 16px;
  }

  @media screen and (max-width: 295px) {
    font-size: 15px;
  }
`;

export const BackIcon = styled(BackOutlined)`
  position: absolute;
  left: 16px;
  font-size: 24px;
  color: #fff;
  cursor: pointer;

  @media screen and (max-width: 325px) {
      width: 24px !important;
  }

  @media screen and (max-width: 295px) {
      width: 23px !important;
  }
`;

export const RightIcon = styled.div`
  position: absolute;
  right: 16px;
  cursor: pointer;

  font-size: 28px;
  color: #fff;

  svg {
    font-size: 28px;
  }

  @media screen and (max-width: 325px) {
    svg {
      width: 24px !important;
    }
  }

  @media screen and (max-width: 295px) {
    svg {
      width: 23px !important;
    }
  }
`;

export const TopBgImage = styled.img.attrs({
  alt: "bg-img",
  src: IMG_TOP_BG,
})`
  position: absolute;
  top: 0;
  width: 100%;
  height: 235px;
`;
